import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Page } from "./types";
import Header from "../components/Header/Header";
import Home from "../pages/Home";
import Footer from "../components/Footer/Footer";
import { Toaster } from "react-hot-toast";
import Notice from "../pages/Notice";
import Policy from "../pages/Policy";

export const pages: Page[] = [{ path: "/", exact: true, component: Home },
  { path: "/mentions-légales", exact: true, component: Notice },
  { path: "/politique-de-confidentialité", exact: true, component: Policy }
];

const PublicRoute = ({ element }: any) => {
  const location = useLocation();

  return element;
};

const MyRoutes = () => {
  return (
    <BrowserRouter>
      <Toaster position="top-right" reverseOrder={false} />

      <Routes>
        {pages.map(({ component, path }) => {
          const Component = component;
          return (
            <Route
              key={path}
              element={<PublicRoute element={<Component />} />}
              path={path}
            />
          );
        })}
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default MyRoutes;
